export default {
    name: 'home'
}
